<template>
  <section class="hero-section">
    <div class="hero-slides">
      <div class="hero-slide" v-for="(slide, index) in slides" :key="index"
           :class="{ active: currentSlide === index }">
        <img :src="slide" alt="">
      </div>
    </div>
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1 class="hero-title" v-html="$t('home.heroTitle')"></h1>
      <p class="hero-subtitle" v-html="$t('home.heroSubTitle')"></p>
      <div class="hero-buttons">
        <router-link :to="{ name: 'shelf' }" class="btn-primary-cta">
          {{ user.uid ? heroButtonTexts[1] : heroButtonTexts[0] }}
          <span class="cta-arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </span>
        </router-link>
        <router-link :to="{ name: 'products' }" class="btn-secondary-cta">
          {{ $t('home.heroButtonMore') }}
          <span class="cta-arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </span>
        </router-link>
      </div>
      <div class="hero-platforms">
        <span class="platforms-label">{{ $t('home.platformsSupported') }}</span>
        <div class="platform-icons">
          <svg class="platform-icon" viewBox="0 0 24 24" fill="currentColor" aria-label="Facebook">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
          <svg class="platform-icon" viewBox="0 0 24 24" fill="currentColor" aria-label="Instagram">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
          </svg>
          <svg class="platform-icon" viewBox="0 0 24 24" fill="currentColor" aria-label="X">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="hero-dots">
      <span v-for="(slide, index) in slides" :key="index"
            :class="{ active: currentSlide === index }"
            @click="goToSlide(index)"></span>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import heroImg1 from '../../../static/images/home/hero-1.jpg'
import heroImg2 from '../../../static/images/home/group-mother.png'
import heroImg3 from '../../../static/images/home/group-lovers.png'
import heroImg4 from '../../../static/images/home/group-lifeman.png'
import heroEn1 from '../../../static/images/home/hero-en1.webp'
import heroEn2 from '../../../static/images/home/hero-en2.jpg'
import stepEn from '../../../static/images/product/step-en.jpeg'
import stepCn from '../../../static/images/product/step-cn.jpeg'

const zhSlides = [stepCn, heroImg1, heroImg2, heroImg3, heroImg4]
const enSlides = [stepEn, heroImg1, heroEn1, heroEn2, heroImg4]

export default {
  name: 'HomeBanner',
  data () {
    return {
      currentSlide: 0,
      timer: null
    }
  },
  computed: {
    ...mapGetters(['user', 'language']),
    slides () {
      return this.language === 'en' ? enSlides : zhSlides
    },
    heroButtonTexts () {
      return this.$t('home.heroButtonStart').split(' | ')
    }
  },
  watch: {
    language () {
      this.currentSlide = 0
      this.stopAutoPlay()
      this.startAutoPlay()
    }
  },
  mounted () {
    this.startAutoPlay()
  },
  beforeDestroy () {
    this.stopAutoPlay()
  },
  methods: {
    startAutoPlay () {
      this.timer = setInterval(function () {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length
      }.bind(this), 4000)
    },
    stopAutoPlay () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    goToSlide (index) {
      this.currentSlide = index
      this.stopAutoPlay()
      this.startAutoPlay()
    }
  }
}
</script>

<style lang="scss">
.hero-section {
  position: relative;
  min-height: 600px;
  display: flex;
  align-items: center;
  color: #fff;
  overflow: hidden;

  .hero-slides {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .hero-slide {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      transition: opacity 1s ease-in-out;

      &.active {
        opacity: 1;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: right center;
      }
    }
  }

  .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      $el-color-primary 0%,
      rgba($el-color-primary, 0.9) 20%,
      rgba($el-color-primary, 0.6) 40%,
      rgba($el-color-primary, 0.2) 60%,
      rgba($el-color-primary, 0) 75%
    );
    z-index: 1;
  }

  .hero-content {
    position: relative;
    z-index: 2;
    max-width: 1140px;
    width: 100%;
    margin: 0 auto;
    padding: 5rem 2rem;
    max-width: 560px;
    margin-left: max(2rem, calc((100vw - 1140px) / 2));
  }

  .hero-title {
    font-size: 2.75rem;
    font-weight: 800;
    line-height: 1.15;
    margin-bottom: 1.25rem;
    color: #fff;
  }

  .hero-subtitle {
    font-size: 1.125rem;
    line-height: 1.7;
    margin-bottom: 2.5rem;
    color: rgba(255, 255, 255, 0.92);
  }

  .hero-buttons {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin-bottom: 2.5rem;
  }

  .cta-arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: rgba(81, 45, 202, 0.15);
    margin-left: 10px;
    transition: background 0.2s;
  }

  .btn-primary-cta {
    display: inline-flex;
    align-items: center;
    padding: 0.875rem 2.25rem;
    background-color: #fff;
    color: $el-color-primary;
    font-size: 1.0625rem;
    font-weight: 600;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.25s;

    &:hover {
      background: linear-gradient(135deg, #F56368, #ff878b);
      color: #fff;
      text-decoration: none;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);

      .cta-arrow {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }

  .btn-secondary-cta {
    display: inline-flex;
    align-items: center;
    padding: 0.875rem 2.25rem;
    background-color: transparent;
    color: #fff;
    font-size: 1.0625rem;
    font-weight: 600;
    border: 2px solid rgba(255, 255, 255, 0.6);
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.25s;

    .cta-arrow {
      background: rgba(255, 255, 255, 0.2);
    }

    &:hover {
      background: linear-gradient(135deg, #F56368, #ff878b);
      border-color: transparent;
      color: #fff;
      text-decoration: none;
      transform: translateY(-2px);

      .cta-arrow {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }

  .hero-platforms {
    .platforms-label {
      display: block;
      font-size: 0.875rem;
      opacity: 0.75;
      margin-bottom: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    .platform-icons {
      display: flex;
      gap: 1.25rem;
      align-items: center;
    }

    .platform-icon {
      width: 28px;
      height: 28px;
      opacity: 0.8;
      transition: opacity 0.2s;

      &:hover {
        opacity: 1;
      }
    }
  }

  .hero-dots {
    position: absolute;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    display: flex;
    gap: 0.5rem;

    span {
      width: 24px;
      height: 3px;
      border-radius: 2px;
      background-color: rgba(255, 255, 255, 0.4);
      cursor: pointer;
      transition: background-color 0.3s, width 0.3s;

      &.active {
        background-color: #fff;
        width: 36px;
      }

      &:hover {
        background-color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}

@media (max-width: 768px) {
  .hero-section {
    min-height: 520px;

    .hero-overlay {
      background: linear-gradient(
        to bottom,
        rgba($el-color-primary, 0.85) 0%,
        rgba($el-color-primary, 0.7) 60%,
        rgba($el-color-primary, 0.4) 100%
      );
    }

    .hero-content {
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      padding: 4rem 1.25rem;
    }

    .hero-title {
      font-size: 2rem;
    }

    .hero-subtitle {
      font-size: 1rem;
      margin-bottom: 2rem;
    }

    .hero-buttons {
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin-bottom: 2rem;
    }

    .btn-primary-cta,
    .btn-secondary-cta {
      width: 100%;
      max-width: 280px;
      text-align: center;
    }

    .hero-platforms {
      .platform-icons {
        justify-content: center;
      }
    }

    .hero-dots {
      bottom: 1.5rem;
    }
  }
}
</style>
